import React, { useRef } from 'react';
import { DetailsRecordingPreview } from './detailsPreview/DetailsPreview';
import { RecordingHeaderWithRouteGuard } from './RecordingHeaderWithRouteGuard';
import { RecorderBody } from './RecorderBody';
import { RECORDING_STATUS } from './types';
import useRecorder from './useRecorder';
import VideoRecorderActions from './VideoRecorderActions';
import { isSafari } from 'lib/utils/browserChecks';
interface IRecordBothProps {
  screenStream: MediaStream;
  stopAllStreams: () => void;
  handleGoToRecordHome: () => void;
  showPreview?: boolean;
  onStartUpladingVoiceOverHandler?: (blob: Blob) => void;
}

export const RecordBoth = ({
  screenStream,
  stopAllStreams,
  handleGoToRecordHome,
  showPreview = true,
  onStartUpladingVoiceOverHandler,
}: IRecordBothProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const {
    stopRecording,
    pauseRecording,
    startCountDown,
    stopCountDown,
    status,
    recordedBlob,
    countdown,
    timeInSeconds,
  } = useRecorder({
    screenStream,
    stopAllStreams,
    onStartUpladingVoiceOverHandler,
    videoRef,
    shouldStartCountdown: !isSafari,
    handleGoToRecordHome,
  });

  if (status === RECORDING_STATUS.DONE && recordedBlob && showPreview) {
    return (
      <DetailsRecordingPreview
        videoBlob={recordedBlob}
        handleGoToRecordHome={handleGoToRecordHome}
      />
    );
  }

  return (
    <>
      <RecordingHeaderWithRouteGuard
        status={status}
        handleGoToRecordHome={handleGoToRecordHome}
      />
      <RecorderBody videoRef={videoRef} countdown={countdown} status={status} />
      <VideoRecorderActions
        startCountDown={startCountDown}
        stopCountDown={stopCountDown}
        pauseRecording={pauseRecording}
        stopRecording={stopRecording}
        status={status}
        timeInSeconds={timeInSeconds}
      />
    </>
  );
};
